import { sendToDatadog, CAMERA_PRESENTER } from '@shoflo/polymer';

import { TOGGLE_AGORA_PRESENTER_LIVE } from 'constants/SocketConstants';
import { MAX_AGORA_CAMERA_COUNT } from '@studio/constants';
import toggleAgoraAttendeeCameraStatus from '@shoflo/studio-redux/actions/attendee/toggleAgoraAttendeeCameraStatus';

import { showNotification } from '../index';

function toggleAgoraPresenterLive() {
  return (dispatch, getState, socket) => {
    const {
      meeting: { attendeeResponse },
      user,
      program,
      attendeeCameraStatus,
      broadcast
    } = getState();

    const { AttendeeId } = attendeeResponse.Attendee;
    const { _id: broadcastId } = broadcast;

    const presenterIsLive = program.layers.some(
      layer => layer.source.value === AttendeeId
    );

    const cameraPresenterCount = program.layers.filter(
      layer => layer.source.type === CAMERA_PRESENTER
    );

    if (
      !presenterIsLive &&
      cameraPresenterCount.length >= MAX_AGORA_CAMERA_COUNT
    ) {
      dispatch(
        showNotification(
          `You're at the max of ${MAX_AGORA_CAMERA_COUNT} sources available at a time in program.`,
          { timeout: 3500, type: 'alert' }
        )
      );
      return;
    }

    const title = `Presenter ${user?._id} toggle live state. Previously ${presenterIsLive}`;
    sendToDatadog('presenter-live-toggle', {}, title, false);
    // If adding to stage and camera is off, turn on the camera
    const isCameraOn = attendeeCameraStatus[AttendeeId] ?? false;
    if (!presenterIsLive && !isCameraOn) {
      dispatch(toggleAgoraAttendeeCameraStatus(AttendeeId, true));
    }
    socket.emit(TOGGLE_AGORA_PRESENTER_LIVE, {
      attendeeId: AttendeeId,
      broadcastId
    });
  };
}

export default toggleAgoraPresenterLive;
